/**
 * Amazing piece of Audience Republic.
 * You deal with UI, and ar-select help you deal with the rest of things.
 * That's it.
 */
var ARSelect = {
render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:[
    'ar-select',
    _vm.isOpen && 'focus',
    _vm.hasError && 'error',
    _vm.disabled && 'disabled',
    !!_vm.direction && _vm.direction ],attrs:{"ar-widget-id":"ar-select","ar-widget-meta":_vm.arWidgetMeta || _vm.computedArWidgetMeta,"name":"ar-select","tabindex":"0","dir":_vm.direction},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }return _vm.handleWrapperTabIn($event)},"keydown":_vm.handleWrapperKeydown}},[_c('div',{class:['display-section', _vm.disabled && 'disabled'],on:{"click":_vm.handleSelectBoxClick}},[(_vm.showInput)?_c('input',{ref:"input",staticClass:"filter-input",attrs:{"placeholder":_vm.filterPlaceholder(_vm.selectedItem)},domProps:{"value":_vm.filterString},on:{"input":_vm.handleFilterStringChange,"keydown":_vm.handleInputKeydown}}):_vm._t("selected-item",null,{"item":_vm.selectedItem})],2),_vm._v(" "),_c('div',{class:[
      'func-icon-section',
      _vm.disabled && 'disabled' ],on:{"click":_vm.handleFuncIconSectionClick}},[(!_vm.hideArrow)?_c('ar-icon',{staticClass:"icon-arrow",attrs:{"width":"10px","name":"arrow","rotate":_vm.isOpen ? 180 : 0}}):_vm._e()],1),_vm._v(" "),_c('div',{ref:"invisible-modal",style:({
      position: 'fixed',
      top: '0',
      left: '0',
      width: '100vw',
      height: '100vh',
      zIndex: _vm.dropdownZIndex,
      display: (_vm.isOpen) ? 'block' : 'none',
      '-webkit-tap-highlight-color': 'rgba(0,0,0,0)',
    }),on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.handleInvisibleModalClick($event)}}}),_vm._v(" "),_c('div',{ref:"select-box-wrapper",style:({
      display: 'inline-block',
      position: 'fixed',
      top: _vm.selectBoxPosition.top,
      bottom: _vm.selectBoxPosition.bottom,
      left: _vm.selectBoxPosition.left,
      width: _vm.selectBoxPosition.width,
      height: _vm.isOpen ? _vm.selectBoxPosition.height : '0',
      opacity: _vm.isOpen ? '1' : '0.7',
      overflow: 'hidden',
      transition: 'height 0.015s, opacity 0.015s',
      zIndex: _vm.dropdownZIndex + 1,
    })},[_c('section',{ref:"select-box",style:(Object.assign({}, {position: 'relative',
        display: 'inline-block',
        borderRadius: '5px',
        background: 'white',
        border: _vm.hideSelectBoxBorder ? null : '1px solid #dcdee4',
        minWidth: '80px',
        overflow: 'auto',
        '-webkit-overflow-scrolling': 'touch',
        width: ("calc(100% - " + (_vm.selectBoxPosition.padding) + " - " + (_vm.selectBoxPosition.padding) + ")"),
        margin: _vm.selectBoxPosition.padding,
        maxHeight: '300px',
        boxShadow: '1px 2px 8px 1px rgba(0, 0, 0, .07)'},
        _vm.dropdownStyle))},[(_vm.displayClearSlot)?_c('div',{style:({
          overflow: 'auto',
        }),on:{"mouseover":function($event){_vm.clearSlotHovered = true;},"mouseleave":function($event){_vm.clearSlotHovered = false;},"click":_vm.handleClearClick}},[_vm._t("clear",null,{"active":_vm.clearSlotHovered,"selectedItem":_vm.selectedItem})],2):_vm._e(),_vm._v(" "),(_vm.displayedItemsCount > 0)?_c('div',{style:({
          overflow: 'auto',
        }),on:{"mouseleave":function($event){_vm.activeIdx = -1;}}},_vm._l((_vm.displayedItems),function(item,idx){return _c('div',{key:idx,ref:"item",refInFor:true,on:{"click":function($event){
        var i = arguments.length, argsArray = Array(i);
        while ( i-- ) argsArray[i] = arguments[i];
return _vm.handleItemClick.apply(void 0, [ idx ].concat( argsArray ))},"mouseover":function($event){_vm.activeIdx = idx;}}},[_vm._t("item",null,{"item":item,"active":_vm.activeIdx === idx,"selected":_vm.selectedIdx === idx,"index":idx,"lastIndex":_vm.displayedItemsCount - 1 === idx})],2)}),0):_c('div',{style:({
          overflow: 'auto',
        })},[_vm._t("no-item")],2)])])])},
staticRenderFns: [],
  name: 'Select',
  props: {
    arWidgetMeta: String,
    items: {
      type: Array,
      default: () => [],
    },
    defaultSelectIndex: {
      type: Number,
      default: -1,
    },
    defaultFilterString: {
      type: String,
      default: null,
    },
    filter: {
      type: Function,
      default: (item, filterString) => {
        return item.name.toLowerCase().indexOf(filterString.toLowerCase()) > -1;
      },
    },
    filterPlaceholder: {
      type: Function,
      default: (selectedItem) => {
        if (selectedItem) {
          return selectedItem.name;
        } else {
          return 'Please select...';
        }
      },
    },
    hideArrow: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    enableClear: {
      type: Boolean,
      default: false,
    },
    enableFilter: {
      type: Boolean,
      default: false,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    showEmptyState: {
      type: Boolean,
      default: true,
    },
    dropdownWidth: {
      type: Number,
      default: null,
    },
    dropdownStyle: {
      type: Object,
      default: () => {},
    },
    align: {
      type: String,
      default: 'left',
      validator: (value) => ['left', 'right'].indexOf(value) !== -1,
    },
    layer: {
      type: String,
      default: 'global-highest',
      validator: (value) => ['global-regular', 'global-high', 'global-highest'].indexOf(value) !== -1,
    },
    direction: {
      type: String || null,
      default: null,
      validator: (value) =>
        ['auto', 'ltr', 'rtl', null].indexOf(value) !== -1,
    },
  },
  data() {
    return {
      initialDisplayedItemsCount: 50,
      selectedIdx: parseInt(this.defaultSelectIndex, 10) > -1 ? this.defaultSelectIndex : -1,
      isOpen: false,
      filterString: '',
      selectBoxPosition: {},
      lockScrollY: null,
      activeIdx: -1,
      clearSlotHovered: false,
    };
  },
  computed: {
    computedArWidgetMeta() {
      return [].join('');
    },
    dropdownZIndex() {
      const zIndexMap = {
        'global-regular': this.$arStyle.zIndex.globalRegular,
        'global-high': this.$arStyle.zIndex.globalHigh,
        'global-highest': this.$arStyle.zIndex.globalHighest,
      };
      return zIndexMap[this.layer];
    },
    displayClearSlot() {
      return this.selectedIdx > -1 && this.enableClear;
    },
    selectedItem() {
      if (this.selectedIdx === -1) {
        return null;
      }
      if (this.items.length === 0) {
        return null;
      }
      return this.items[this.selectedIdx];
    },
    showInput() {
      return this.isOpen && this.enableFilter;
    },
    displayedItems() {
      if (this.enableFilter && !!this.filterString) {
        // Don't filter out action items, only filter out non-action items.
        return this.items
            .filter(item => item.isAction || this.filter(item, this.filterString))
            .slice(0, this.initialDisplayedItemsCount);
      } else {
        return this.items;
      }
    },
    displayedItemsCount() {
      return this.displayedItems.length;
    },
    hideSelectBoxBorder() {
      return !this.$slots['no-item'] && this.displayedItems.length === 0;
    },
  },
  watch: {
    defaultSelectIndex(newVal) {
      this.selectedIdx = parseInt(newVal, 10) > -1 ? newVal : -1;
    },
    displayedItems(newVal) {
      // Remember to reresh activeIdx everytime it changes
      this.activeIdx = -1;
      if (newVal.length === 0 && !this.showEmptyState) {
        this.isOpen = false;
      }
    },
    items() {
      this.$nextTick(() => {
        this.updateSelectPosition();
      });
    },
    isOpen(val) {
      if (val) {
        this.$emit('open');
      } else {
        this.$emit('close');
      }
      if (val) {
        // Lock scroll
        this.lockScrollY = window.scrollY;
        window.addEventListener('scroll', this.handleScroll);

        // Init input
        if (this.enableFilter) {
          this.initInput();
        }
        // If you have defaultFilterString
        if (this.defaultFilterString) {
          this.inputFilterString(this.defaultFilterString);
        }

        if (this.initialDisplayedItemsCount < this.items.length) {
          this.lazyLoadLongItems();
        }

        this.updateSelectPosition();
      } else {
        setTimeout(() => {
          this.filterString = '';
        }, 200);
        this.activeIdx = -1;

        window.removeEventListener('scroll', this.handleScroll);
      }
    }
  },
  created() {
    window.addEventListener('resize', this.handleWindowResize);
  },
  mounted() {
    this.attachSelectBoxToBody();
    this.updateSelectPosition();
    addEventListener('keydown', this.handleKeyPress);
  },
  beforeDestroy() {
    this.removeSelectBoxFromBody();
    window.removeEventListener('resize', this.handleWindowResize);
    window.removeEventListener('scroll', this.handleScroll);
    removeEventListener('keydown', this.handleKeyPress);
  },
  methods: {
    // For external uses, don't delete it
    toggleDropdown(isOpen) {
      this.isOpen = isOpen;
      if (isOpen) {
        this.$el.blur();
      }
    },

    // Just attach the dialog to body level, remove it when we don't need it anymore
    attachSelectBoxToBody() {
      document.body.appendChild(this.$refs['invisible-modal']);
      document.body.appendChild(this.$refs['select-box-wrapper']);
    },
    removeSelectBoxFromBody() {
      document.body.removeChild(this.$refs['invisible-modal']);
      document.body.removeChild(this.$refs['select-box-wrapper']);
    },
    updateSelectPosition() {
      const selectBoxHt = this.$refs['select-box'].offsetHeight;
      const elementHt = this.$el.offsetHeight;
      const elementWd = this.$el.offsetWidth;
      const dropdownWidth = this.dropdownWidth ? this.dropdownWidth : elementWd;
      const { top, left, bottom, right } = this.$el.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const padding = 5;
      const adjustedLeft = (this.align === "right") ? right - dropdownWidth - 2 - padding : left - 1 - padding;
      
      if (selectBoxHt + top + elementHt > windowHeight) {
        this.selectBoxPosition = {
          bottom: `${windowHeight - top + 5 - padding}px`,
          left: `${adjustedLeft}px`,
          width: `${dropdownWidth + 2 + padding * 2}px`,
          height: `${selectBoxHt + padding * 2}px`,
          padding: `${padding}px`
        };
      } else {
        this.selectBoxPosition = {
          top: `${top + elementHt + 5 - padding}px`,
          left: `${adjustedLeft}px`,
          width: `${dropdownWidth + 2 + padding * 2}px`,
          height: `${selectBoxHt + padding * 2}px`,
          padding: `${padding}px`
        };
      }
    },
    initInput() {
      setTimeout(() => {
        if (this.$refs.input) {
          this.$refs.input.focus();
        }
      }, 50);
    },
    resetTabindex() {
      this.$el.focus();
      this.$el.blur();
    },
    inputFilterString(filterString) {
      this.filterString = filterString;
      this.$refs['select-box'].scrollTop = 0;

      setTimeout(this.updateSelectPosition, 30);
      this.$emit('filterStringInput', filterString);
    },
    lazyLoadLongItems() {
      this.initialDisplayedItemsCount = this.items.length;
    },
    handleInvisibleModalClick(event) {
      this.isOpen = false;

      // Remember to move tabIndex back to this component !
      this.resetTabindex();
    },
    handleFilterStringChange(event) {
      this.inputFilterString(event.target.value);
    },
    handleInputDeletePress() {
      if (this.$refs.input.value === '' && this.enableClear) {
        this.selectedIdx = -1;
        this.$emit('clear');
        this.isOpen = false;
      }
    },
    handleClearClick() {
      if (!this.enableClear) {
        return;
      }
      if (this.$refs.input) {
        this.$refs.input.value = '';
      }
      this.clearSlotHovered = false;
      this.selectedIdx = -1;
      this.isOpen = false;
      this.$emit('clear');
    },
    handleWindowResize() {
      this.updateSelectPosition();
    },
    handleScroll(event) {
      if (this.items.length === 0) {
        return;
      }

      event.preventDefault();
      window.scrollTo(window.scrollX, this.lockScrollY);
      event.stopPropagation();
    },
    handleWrapperEscapeKeyDown() {
      this.$el.blur();
      if (this.enableFilter && this.isOpen) {
        this.$refs.input.blur();
      }
    },
    handleOpenSelectPress() {
      if (this.$el === document.activeElement) {
        this.isOpen = true;
      }
    },
    handleSelectBoxClick() {
      if (!this.disabled) {
        this.toggleDropdown(!this.isOpen);
      }
    },
    handleFuncIconSectionClick() {
      if (this.disabled) return;
      this.isOpen = !this.isOpen;
      if (!this.isOpen) {
        this.$el.blur();
      }
    },
    // When user use tab to focus the element
    handleWrapperTabIn(event) {
      if (!this.disabled) {
        this.isOpen = true;
      }
    },
    handleWrapperKeydown(event) {
      const key = event.key;
      if (key === 'ArrowDown' || key === 'Enter') {
        event.preventDefault();
        this.handleOpenSelectPress();
      } else if (key === 'Tab') {
        this.isOpen = false;
      } else if (key === 'Escape') {
        this.handleWrapperEscapeKeyDown();
      } else if (key === 'Page Up') {
        event.preventDefault();
        event.stopPropagation();
      } else if (key === 'Page Down') {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    handleInputKeydown(event) {
      const key = event.key;
      if (key === 'Backspace') {
        this.handleInputDeletePress();
      } else if (key === 'Tab') {
        this.isOpen = false;
      } else if (key === 'Escape') {
        this.isOpen = false;
      } else if (key === 'Page Up') {
        event.preventDefault();
        event.stopPropagation();
      } else if (key === 'Page Down') {
        event.preventDefault();
        event.stopPropagation();
      } else if (key === 'Enter') {
        if (this.activeIdx > -1 && this.displayedItems[this.activeIdx]) {
          this.handleItemClick(this.activeIdx);
        } else if (this.activeIdx === -1 && this.filterString.length > 0 && this.displayedItems[0]) {
          this.handleItemClick(0);
        } else if (this.activeIdx === -1 && this.selectedIdx === -1 && this.displayedItems[0]) {
          this.handleItemClick(0);
        }
        this.isOpen = false;
      }
    },
    scrollSelectBox(direction, idx) {
      const wrapperEl = this.$refs['select-box'];
      const itemEl = this.$refs.item[idx];
      if (!wrapperEl || !itemEl) {
        return;
      }

      if (itemEl.offsetTop > wrapperEl.scrollTop + wrapperEl.offsetHeight * 0.5 && direction == 'down') {
        wrapperEl.scrollTop += itemEl.offsetHeight;
      }
      if (itemEl.offsetTop < wrapperEl.scrollTop + wrapperEl.offsetHeight * 0.5 && direction == 'up') {
        wrapperEl.scrollTop -= itemEl.offsetHeight;
      }
    },
    handleItemClick(idx, event) {
      let selectedItem = this.displayedItems[idx];
      const isAction = selectedItem.isAction;

      // don't change the selectedIdx if the user has clicked an 'action' item
      if (!isAction) {
        if (this.enableFilter) {
          // The items might be filtered so the index may not be correct.
          // User findIndex on the original items props.
          const originalIdx = this.items.findIndex(item => {
            return item.name === selectedItem.name
          });
          this.selectedIdx = originalIdx;
        } else {
          this.selectedIdx = idx;
        }
      }


      this.isOpen = false;
      /**
       * Remember to stop propagating the event from ar-dialog-select
       * Otherwise for all the components using ar-simple-select, it's like your clicked 'outside' the component,
       * because we attach dialog to body level.
       */
      if (event && event.stopPropagation()) {
        event.stopPropagation();
      }

      if (isAction){
        this.$emit('actionClick', selectedItem);
      } else {
        this.$emit('select', selectedItem, this.selectedIdx);
      }


      // Remember to move tabIndex back to this component !
      this.resetTabindex();
    },
    handleKeyPress(event) {
      // Only enable it when it's opened
      if (!this.isOpen) {
        return;
      }
      let activeIdx = this.activeIdx;
      if (event.key === 'ArrowUp') {
        if (activeIdx > 0) {
          activeIdx -= 1;
        }
        this.activeIdx = activeIdx;
        this.scrollSelectBox('up', activeIdx);
      } else if (event.key === 'ArrowDown') {
        // Keep looking down until we find displayed item, cuz we might have filter
        if (activeIdx < this.displayedItems.length - 1) {
          activeIdx += 1;
        }
        this.activeIdx = activeIdx;
        this.scrollSelectBox('down', activeIdx);
      } else if (event.key === 'Enter' && this.activeIdx > -1) {
        this.handleItemClick(activeIdx, event);
      }
    }
  }
};

export default ARSelect;
